import { type StateCreator } from 'zustand';
import { type SearchFilterRequestPreferences } from '@ev-tech/search-modules-api';

import { type MiddlewareType, type SearchStore } from '../SearchStoreProvider';

export type UIFacingPreferences = Omit<SearchFilterRequestPreferences, `EV_${string}`>;

export type PreferencesState = {
  preferences?: UIFacingPreferences;
  isPreferencesUnavailable?: boolean;
};

type PreferencesActions = {
  setPreferences: (preferences?: UIFacingPreferences) => void;
  setIsPreferencesUnavailable: (isPreferencesUnavailable?: boolean) => void;
};

export type PreferencesStore = PreferencesState & PreferencesActions;

export const DEFAULT_PREFERENCES: UIFacingPreferences = {};

export const defaultPreferencesState: Readonly<PreferencesState> = {
  preferences: DEFAULT_PREFERENCES,
};

export const createPreferencesSlice: StateCreator<SearchStore, MiddlewareType, [], PreferencesStore> = (set) => {
  return {
    ...defaultPreferencesState,
    setPreferences: (preferences?: UIFacingPreferences) => set({ preferences, page: 1 }, undefined, 'setPreferences'),
    setIsPreferencesUnavailable: (isPreferencesUnavailable) => set({ isPreferencesUnavailable }, undefined, 'setIsPreferencesUnavailable'),
  };
};
